import React from 'react'
import EvaluatorHome from '../Company/CompanyHome/EvaluatorHome'
import HomePage from '../Company/CompanyHome/HomePage'

function CompanyHome() {
  return (
    <>
        <HomePage />
    </>
  )
}

export default CompanyHome
